import { lazy, Suspense } from "react";
import { Link } from "react-router";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import useModal from "@/hooks/use-modal";
const DeleteServiceModal = lazy(() =>
    import("./delete-service").then((module) => ({
        default: module.DeleteServiceModal,
    })),
);
import {
    ClockIcon,
    PencilIcon,
    TrashIcon,
    ArrowUturnRightIcon,
} from "@heroicons/react/24/outline";

export const ServiceItem = ({ service, serviceTypeMap }) => {
    const deleteServiceModal = useModal();

    const serviceTypeTitles = (
        Array.isArray(service.serviceTypes)
            ? service.serviceTypes
            : service.serviceTypes?.split(",") || []
    )
        .map((id) => serviceTypeMap[id])
        .filter(Boolean);

    return (
        <>
            <Card size="lg" className="grid-cols-12 gap-y-4">
                <div className="col-span-full flex flex-col gap-2 text-base/5 text-neutral-500 lg:col-span-8 xl:col-span-9">
                    <div className="flex flex-wrap content-start items-end gap-[inherit]">
                        <p className="text-xl font-semibold text-darkgreen-500">
                            {service.serviceTitle}
                        </p>
                        {serviceTypeTitles.map((service) => (
                            <Badge key={service} variant="secondary">
                                {service}
                            </Badge>
                        ))}
                    </div>
                    <div className="w-full">
                        <p className="mb-1 text-sm">
                            {service.serviceDescription}
                        </p>
                    </div>
                    <div className="flex flex-1 justify-between gap-[inherit]">
                        <div className="flex flex-col gap-[inherit]">
                            <div className="flex gap-3">
                                <div
                                    className="flex items-center gap-1"
                                    title="Appointment length"
                                >
                                    <ClockIcon className="size-5" />
                                    <p>{service.appointmentLength}</p>
                                </div>
                                <div
                                    className="flex items-center gap-1"
                                    title="Turnaround length"
                                >
                                    <ArrowUturnRightIcon className="size-5" />
                                    <p>{service.turnaroundLength}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-1">
                                <p>£{service.appointmentPrice.toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="col-span-full ms-auto mt-auto hidden gap-[inherit] md:col-span-4 md:flex lg:hidden xl:col-span-3">
                            <Button variant="secondary" size="sm" asChild>
                                <Link
                                    to={`/clinician/services/edit/${service.serviceGuid}`}
                                >
                                    <PencilIcon className="size-5" />
                                    Amend
                                </Link>
                            </Button>
                            <Button
                                type="button"
                                variant="danger"
                                size="sm"
                                onClick={() => deleteServiceModal.open()}
                            >
                                <TrashIcon className="size-5" />
                                Delete
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="col-span-full ms-auto mt-auto flex gap-2 md:hidden lg:col-span-4 lg:flex xl:col-span-3">
                    <Button variant="secondary" size="sm" asChild>
                        <Link
                            to={`/clinician/services/edit/${service.serviceGuid}`}
                        >
                            <PencilIcon className="size-5" />
                            Amend
                        </Link>
                    </Button>
                    <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        onClick={() => deleteServiceModal.open()}
                    >
                        <TrashIcon className="size-5" />
                        Delete
                    </Button>
                </div>
            </Card>
            <Suspense fallback={null}>
                <DeleteServiceModal
                    isOpen={deleteServiceModal.isOpen}
                    onClose={() => deleteServiceModal.close()}
                    serviceGuid={service.serviceGuid}
                    title={service.serviceTitle}
                />
            </Suspense>
        </>
    );
};
